module.exports = __webpack_public_path__ + "static/media/POR.1a3668a6.png";